module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-4912ebb880ab2f51d803d4cf16b7fa23.png";